'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PromoDataRecord = undefined;

var _immutable = require('immutable');

var PromoDataRecord = exports.PromoDataRecord = (0, _immutable.Record)({
    id: '',
    url: '',
    name: '',
    promoCode: '',
    termsText: '',
    termsLink: '',
    termsUrl: '',
    promoText: '',
    promoLink: '',
    defaultUrl: ''
});
//# sourceMappingURL=model.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/promo-codes/model.js
// module id = 455
// module chunks = 0